<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)" :id="'transaction-filter-form'+ form_id">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col v-if="$can('read', 'transaction')" xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="user_id">
                                                {{ $t('label.user_id') }}
                                            </kt-form-label>
                                            <kt-form-control ref="user_id" dir="ltr" name="user_id" id="user_id" v-model="query.user_id" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-if="$can('read', 'transaction')" xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="fullname">
                                                {{ $t('label.fullname') }}
                                            </kt-form-label>
                                            <kt-form-control ref="fullname" name="fullname" id="fullname" v-model="query.fullname" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-if="$can('read', 'transaction')" xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="shop_farsi_name">
                                                {{ $t('label.farsi_name') }}
                                            </kt-form-label>
                                            <kt-form-control ref="shop_farsi_name" name="shop_farsi_name" id="shop_farsi_name" v-model="query.shop_farsi_name" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-label for="filter_gateway">
                                            {{ $t('label.gateway') }}
                                        </kt-form-label>
                                        <select
                                                class="form-control"
                                                v-model=filter_gateway
                                                name = "filter_gateway"
                                                id="filter_gateway"
                                        >
                                            <option
                                                    :key="index"
                                                    v-for="(data, index) in shop_data_gateway"
                                                    :value = data
                                            >
                                                {{ data.title+"  -  "+getShopType(data.shop_type)+"  -  "+data.sequence}}
                                            </option>
                                        </select>
                                    </kt-col>
                                    
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="id">
                                                {{ $t('label.transaction_id') }}
                                            </kt-form-label>
                                            <kt-form-control ref="id" dir="ltr" name="id" id="id" v-model="query.id" />
                                        </kt-form-group>
                                    </kt-col>
                                    
                                  <kt-col  xs="12" sm="6" md="4">
                                    <kt-form-group>
                                      <kt-form-label for="order_id">
                                        {{ $t('label.order_id') }}
                                      </kt-form-label>
                                      <kt-form-control ref="order_id" dir="ltr" name="order_id"
                                                       id="order_id" v-model="query.order_id"
                                      />
                                    </kt-form-group>
                                  </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="ref_id">
                                                {{ $t('label.transaction_ref_id') }}
                                            </kt-form-label>
                                            <kt-form-control ref="ref_id" dir="ltr" name="ref_id"
                                                             id="ref_id" v-model="query.ref_id"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="price">
                                                {{ $t('label.price') }}
                                            </kt-form-label>
                                            <kt-form-control ref="price" name="price" id="price" v-model="query.price"></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="card_number">
                                                {{ $t('label.card_number') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="card_number"
                                                    name="card_number"
                                                    id="card_number"
                                                    style="direction:ltr"
                                                    v-bind:placeholder="$t('label.card_number_sample')"
                                                    v-model="query.card_number"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group ref="statusSelectGroup">
                                            <kt-form-label for="status">
                                                {{ $t('label.status') }}
                                            </kt-form-label>
                                            <kt-form-select size="5" id="status" class="form-control"
                                                            name="status" v-model="query.status"
                                            >
                                                <option
                                                        v-bind:key="index"
                                                        v-for="(status, index) in statuses"
                                                        v-bind:value="status.value"
                                                        :selected="query.status === status.value"
                                                >
                                                    {{ status.name }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="12">
                                        <kt-form-group ref="statusSelectGroup">
                                            <kt-form-label for="status">
                                                {{ $t('label.transaction_type') }}
                                            </kt-form-label>
                                            <select
                                                size="5"
                                                multiple
                                                id="transaction_type"
                                                name="transaction_type"
                                                v-model="query.transaction_type"
                                                class="form-control kt-selectpicker"
                                            >
                                                <option
                                                      v-bind:key="index"
                                                      v-for="(transaction_type, index) in types"
                                                      v-if="transaction_type.name !== undefined"
                                                      v-bind:value="transaction_type.value"
                                                      :selected="query.transaction_type === transaction_type.value"
                                                >
                                                    {{ transaction_type.name }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name= "from_date"
                                                    v-model="query.from_date"
                                                    type="datetime" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    type="button"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name= "to_date"
                                                    v-model="query.to_date"
                                                    type="datetime"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="ref_num">
                                                {{ $t('label.ref_num') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="ref_num"
                                                    name="ref_num"
                                                    id="ref_num"
                                                    v-model="query.ref_num"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col  xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="phone">
                                                {{ $t('label.phone') }}
                                            </kt-form-label>
                                            <kt-form-control ref="phone" dir="ltr" name="phone"
                                                             id="phone" v-model="query.phone"
                                            />
                                        </kt-form-group>
                                    </kt-col>

                                    <!-- Psp -->
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group ref="statusSelectGroup">
                                            <kt-form-label for="status">
                                                {{ $t('label.psp') }}
                                            </kt-form-label>
                                            <kt-form-select size="5" id="transaction_type" class="form-control"
                                                            name="transaction_type" v-model="query.psp"
                                            >
                                                <option value=""></option>
                                                <option
                                                        v-bind:key="index"
                                                        v-for="(psp_type, index) in pspTypes"
                                                        v-bind:value="psp_type.value"
                                                        :selected="query.psp_type === psp_type.value"
                                                >
                                                    {{ psp_type.name }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col  xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="sheba">
                                                {{ $t('label.sheba_number') }}
                                            </kt-form-label>
                                            <kt-form-control ref="sheba" dir="ltr" name="sheba"
                                                             id="sheba" v-model="query.sheba"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                  <kt-col xs="12" sm="6" md="6">
                                    <kt-form-group>
                                      <kt-form-label for="filter_gateway">
                                        {{ $t('label.gateway') }}
                                      </kt-form-label>
                                      <select class="form-control" v-model="selectedShop" name="filter_gateway" id="filter_gateway">
                                        <option
                                            v-for="shop in shop_data_gateway"
                                            :key="shop.hashid"
                                            :value="shop"
                                        >
                                          {{ shop.title }} - {{ getShopType(shop.shop_type) }} - {{ shop.sequence }}
                                        </option>
                                      </select>
                                    </kt-form-group>
                                  </kt-col>
                                  <kt-col xs="12" sm="6" md="6">
                                    <kt-form-group>
                                      <kt-form-label for="terminal_number">
                                        {{ $t('label.terminal_number') }}
                                      </kt-form-label>
                                      <select  class="form-control" v-model="query.terminal_number"  name="terminal_number" id="terminal_number"   >
                                        <option
                                            v-for="terminal in filteredTerminals"
                                            :key="terminal.id"
                                            :value="terminal.id"
                                        >
                                          {{ $t(`psp.${terminal.psp}`) }} - {{ terminal.number || 'N/A' }}
                                        </option>
                                      </select>
                                    </kt-form-group>
                                  </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <kt-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                    </kt-col>
                                </kt-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
    import { statusStr, transactionStatus } from '@/constants/transactionStatus'
    import { transactionTypes, transactionStr } from '@/constants/transactionTypes'
    import Inputmask from 'inputmask'
    import axios from "axios";
    import { ApiUrl } from '@/common/api.service'
    import  { AllShopTypes } from "@/constants/AllShopTypes"
    import {mapGetters} from "vuex";
    import { i18n } from "@/plugins/i18n";
    import $ from "jquery";

    export default {
        props: {
            action: {
                default: function(e, query) {},
                required: true,
            },
            query: {
                required: true,
                default: {},
            },
            form_id: {
                required: true,
                default: '',
            },

        },
        watch: {
            filter_gateway(value) {
                this.query.shop_type   = value.shop_type;
                this.query.shop_hashid = value.hashid;
            },
            selectedShop(newShop) {
              this.filteredTerminals = newShop ? newShop.terminals : [];
              this.selectedTerminal = null;
            }
        },
        data() {
            return {
                statuses: [
                    {
                        name: null,
                        value: null
                    },
                    {
                        name: statusStr.INIT,
                        value: transactionStatus.INIT
                    },
                    {
                        name: statusStr.FAILED,
                        value: transactionStatus.FAILED
                    },
                    {
                        name: statusStr.SUCCEED,
                        value: transactionStatus.SUCCEED
                    },
                    {
                        name: statusStr.CANCELED,
                        value: transactionStatus.CANCELED
                    },
                    {
                        name: statusStr.REVERSED,
                        value: transactionStatus.REVERSED
                    },
                    {
                      name: statusStr.SWITCHED,
                      value: transactionStatus.SWITCHED
                    },
                    {
                      name: statusStr.EXPIRED,
                      value: transactionStatus.EXPIRED
                    },
                    {
                      name: statusStr.VERIFY_PENDING,
                      value: transactionStatus.VERIFY_PENDING
                    },
                    {
                      name: statusStr.UNVERIFIED,
                      value: transactionStatus.UNVERIFIED
                    }
                ],
                types: [
                  {
                    name: null,
                    value: null
                  },
                  {
                    name: transactionStr.API,
                    value: transactionTypes.API
                  },
                  {
                    name: transactionStr.SMS_WALLET_RECHARGE,
                    value: transactionTypes.SMS_WALLET_RECHARGE
                  },
                  {
                    name: transactionStr.ENAMAD_REGISTER,
                    value: transactionTypes.ENAMAD_REGISTER,
                  },
                  {
                    name: transactionStr.OPEN_BANKING_WALLET_RECHARGE,
                    value: transactionTypes.OPEN_BANKING_WALLET_RECHARGE,
                  },
                  {
                    name: transactionStr.PAYMENT_HELPER_PSP_SETTLEMENT,
                    value: transactionTypes.PAYMENT_HELPER_PSP_SETTLEMENT,
                  },
                  {
                    name: transactionStr.ONLINE_CONTRACT_PRICE,
                    value: transactionTypes.ONLINE_CONTRACT_PRICE,
                  },
                ],
                pspTypes: [
                    {
                        name: "پرداخت نوین",
                        value: "NOVIN"
                    },
                    {
                        name: "به پرداخت ملت",
                        value: "Mellat"
                    },
                    {
                        name: "پارسیان",
                        value: "PARSIAN"
                    },
                    {
                        name: "پاسارگاد",
                        value: "PASARGAD"
                    },
                    {
                        name: "سامان",
                        value: "Saman"
                    },
                    {
                        name: "سپهر",
                        value: "Sepehr"
                    },
                    {
                        name: "ایران کیش",
                        value: "Irankish"
                    },
                    {
                        name: "آسان پرداخت",
                        value: "Asanpardakht"
                    },
                    {
                        name: "صادرات",
                        value: "Saderat"
                    },
                ],
                // query: {},
                filter_gateway: null,
                selectedShop: null,
                selectedTerminal: null,
                filteredTerminals: [],
            }
        },
        computed : {
            ...mapGetters('gateway', [
                'shop_data_gateway',
                'shop_data_gateway_status'
            ]),
        },
        mounted() {
            this.initial()
            this.$store.dispatch('gateway/fetchShopData').finally(()=>{
                this.afterDispatch()
            })
        },
        methods: {
            getShopType(shop_type) {
                if (shop_type == AllShopTypes.PAYMENT_HELPER) {
                    return  i18n.t('label.payment_helper')
                }
                if (shop_type == AllShopTypes.PAYMAN) {
                    return  i18n.t('label.payman')
                }
                if (shop_type == AllShopTypes.IVR) {
                    return  i18n.t('label.ivr')
                }
                if (shop_type == AllShopTypes.DEDICATED) {
                    return  i18n.t('label.dedicated')
                }
            },

            initial() {
                Inputmask('9999-99-99').mask(document.querySelectorAll('.maskable'))
            },
            clearFromDate() {
                if(this.query.from_date) {
                    this.query.from_date = null
                }
            },
            clearToDate() {
                if(this.query.to_date) {
                    this.query.to_date = null
                }
            },
            afterDispatch() {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                });


                document.getElementById('phone') && Inputmask('09999999999').mask(document.getElementById('phone'))
                document.getElementById('sheba') && Inputmask('IR99-9999-9999-9999-9999-9999-99').mask(document.getElementById('sheba'))
            },
        }
    }
</script>

<style>
    #card_number:-moz-placeholder {
        text-align: right;
    }

    #card_number:-ms-input-placeholder {
        text-align: right;
    }

    #card_number::-webkit-input-placeholder {
        text-align: right;
    }
</style>
